// FT-087: единый источник словарей типов/КПП/топлива для новых страниц /cars/*.
// Значения хранятся в БД кириллицей (как New.vue data()); slug = i18n-ключ — он же
// латинский идентификатор в URL (REQ-09). Словарь типа зависит от вида транспорта
// company.rental_object (cars | bicycles | motorcycles), как current_object_types.
export const CAR_TYPES = [
  { slug: "micro", value: "Микро" },
  { slug: "hatchback", value: "Хэтчбек" },
  { slug: "sedan", value: "Седан" },
  { slug: "universal", value: "Универсал" },
  { slug: "minivan", value: "Минивен" },
  { slug: "coupe", value: "Купе" },
  { slug: "crossover", value: "Кроссовер" },
  { slug: "suv", value: "Внедорожник" },
  { slug: "pickup", value: "Пикап" },
  { slug: "limousine", value: "Лимузин" },
  { slug: "van", value: "Фургон" },
  { slug: "cabriolet", value: "Кабриолет" },
  { slug: "bus", value: "Микроавтобус" },
  { slug: "campervan", value: "Автодом" },
  { slug: "light_van", value: "Легковой фургон" },
  { slug: "rodster", value: "Родстер" },
  { slug: "sportcar", value: "Спорткар" },
];
export const BIKE_TYPES = [
  { slug: "road", value: "Шоссейные" },
  { slug: "mtb", value: "Горные (MTB)" },
  { slug: "city", value: "Городские" },
  { slug: "hybrid", value: "Гибридные" },
  { slug: "track", value: "Трековые" },
  { slug: "gravel", value: "Гравийные (гревел)" },
  { slug: "folding", value: "Складные" },
  { slug: "bmx", value: "BMX" },
  { slug: "tourist", value: "Туристические" },
  { slug: "triathlon", value: "Для триатлона" },
  { slug: "fatbike", value: "Фэтбайки" },
  { slug: "cruiser", value: "Круизеры" },
  { slug: "downhill", value: "Даунхилл" },
  { slug: "children", value: "Детские" },
  { slug: "tandem", value: "Тандемы" },
  { slug: "electric", value: "Электрические" },
  { slug: "trick", value: "Трюковые" },
  { slug: "offroad", value: "Внедорожные" },
  { slug: "sport", value: "Спортивные" },
  { slug: "seat", value: "Самокаты с сиденьем" },
  { slug: "scooter", value: "Гироскутеры" },
  { slug: "kick", value: "Кикскутеры" },
  { slug: "speed", value: "Быстроходные" },
];
export const MOTORCYCLE_TYPES = [
  { slug: "sport", value: "Спортивные (спортбайки)" },
  { slug: "cruiser", value: "Круизеры" },
  { slug: "tourist", value: "Туристические (турэндуро)" },
  { slug: "enduro", value: "Эндуро" },
  { slug: "standard", value: "Стандартные (нейкед)" },
  { slug: "scooter", value: "Скутеры" },
  { slug: "chopper", value: "Чопперы" },
  { slug: "cafe_racer", value: "Кафе рейсеры" },
  { slug: "kross", value: "Кроссовые (мотокросс)" },
  { slug: "super", value: "Супермото" },
  { slug: "street", value: "Стритфайтеры" },
  { slug: "sport_tourist", value: "Спорт-туристические" },
  { slug: "moped", value: "Мопеды" },
  { slug: "truck", value: "Трайки (трехколесные)" },
  { slug: "bobber", value: "Боббер" },
  { slug: "buggy", value: "Багги" },
];
export const GEARS = [
  { slug: "automatic", value: "Автомат" },
  { slug: "manual", value: "Механика" },
  { slug: "variator", value: "Вариатор" },
  { slug: "robot", value: "Робот" },
];
export const FUELS = [
  { slug: "gas", value: "Бензин" },
  { slug: "gas_92", value: "Бензин 92" },
  { slug: "gas_95", value: "Бензин 95" },
  { slug: "gas_98", value: "Бензин 98" },
  { slug: "gas_100", value: "Бензин 100" },
  { slug: "disel", value: "Дизель" },
  { slug: "gas_natural", value: "Газ" },
  { slug: "gas_gasoline", value: "Бензин/Газ" },
  { slug: "electricity", value: "Электричество" },
  { slug: "hybrid", value: "Гибрид" },
  { slug: "hydrogen", value: "Водород" },
];

export function typeDictFor(rentalObject) {
  if (rentalObject === "bicycles") return BIKE_TYPES;
  if (rentalObject === "motorcycles") return MOTORCYCLE_TYPES;
  return CAR_TYPES;
}

function toSlugMap(list) {
  return Object.fromEntries(list.map((e) => [e.value, e.slug]));
}
function fromSlugMap(list) {
  return Object.fromEntries(list.map((e) => [e.slug, e.value]));
}
// car_type: все три словаря в одной карте (слаг уникален внутри словаря; коллизии
// между словарями безопасны — у компании один rental_object)
const ALL_TYPES = [...CAR_TYPES, ...BIKE_TYPES, ...MOTORCYCLE_TYPES];
export const SLUG_MAPS = {
  toSlug: {
    car_type: toSlugMap(ALL_TYPES),
    transmission: toSlugMap(GEARS),
    fuel: toSlugMap(FUELS),
  },
  fromSlug: {
    car_type: fromSlugMap(ALL_TYPES),
    transmission: fromSlugMap(GEARS),
    fuel: fromSlugMap(FUELS),
  },
};
